import React from "react";
import { Col, Row } from "react-bootstrap";
import { FormattedMessage } from "@irati/utils/lang";
import { Label } from "@irati/ui/src/Typography";
import ColHeader from "../styled/ColHeader";
import { StyledRow } from "../styled/MyPerksList";
var RedemptionHeaders = function () {
    return (React.createElement(StyledRow, null,
        React.createElement(Col, { smOffset: 2, sm: 7 },
            React.createElement(Row, null,
                React.createElement(Col, { sm: 7 },
                    React.createElement(ColHeader, null,
                        React.createElement(Label, null,
                            React.createElement(FormattedMessage, { id: "perks.components.myPerks.myPerksList.title" })))),
                React.createElement(Col, { sm: 2 },
                    React.createElement(ColHeader, null,
                        React.createElement(Label, null,
                            React.createElement(FormattedMessage, { id: "perks.components.myPerks.myPerksList.quantity" })))),
                React.createElement(Col, { sm: 3 },
                    React.createElement(ColHeader, null,
                        React.createElement(Label, null,
                            React.createElement(FormattedMessage, { id: "perks.components.myPerks.myPerksList.redeemed" })))))),
        React.createElement(Col, { sm: 2 },
            React.createElement(ColHeader, null,
                React.createElement(Label, null,
                    React.createElement(FormattedMessage, { id: "perks.myPerks.myPerksList.actions" }))))));
};
export default RedemptionHeaders;
